import StyleFactory, { getLineValueFromFeature } from '../../StyleFactory';
export const themeSelector = (value, theme, feature, resolution, params, viewOptions, view, additionalOptions) => {
  //Case for MaxIceConcentration style
  if (additionalOptions && additionalOptions.maxConcentrationFn) {
    const maxVal = additionalOptions.maxConcentrationFn();

    if (maxVal % 10 !== 0 || maxVal < 0 || maxVal > 90 || value !== maxVal) {
      return {
        color: 'transparent'
      };
    }

    return {
      color: theme.color,
      width: theme.width
    };
  }
};
export default {
  line: StyleFactory.createStyle({
    valueSelector: getLineValueFromFeature,
    labelSelector: null,
    themeSelector
  })
};